var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransition = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.94124 3.99572C7.49378 3.28344 8.67224 3.66302 8.6724 4.59771V13.8293C8.67229 14.3649 8.23812 14.7992 7.7025 14.7992H1.68643C0.916475 14.7992 0.453438 13.945 0.873566 13.2999L6.88964 4.06826L6.94124 3.99572Z",
    fill: "#BFBBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7573 4.59771C10.7574 3.66306 11.9359 3.28355 12.4884 3.99572L12.54 4.06826L18.5561 13.2999C18.9763 13.945 18.5132 14.7992 17.7432 14.7992H11.7272C11.1916 14.7992 10.7574 14.3649 10.7573 13.8293V4.59771Z",
    fill: "#BFBBCF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transition.0a41feeec920a1d76e355d67384df3ca.svg";